import React from 'react';
import { 
  Database, 
  Shield, 
  Users, 
  TrendingUp, 
  CheckCircle, 
  Globe, 
  Beaker, 
  FileText,
  BarChart3,
  Settings,
  Zap,
  Target
} from 'lucide-react';
import { Link } from 'react-router-dom';
const InforPLMProcess = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: '#f9fafb' }}>
    
    

      {/* Hero Section */}
      <section className="py-16" style={{ background: 'linear-gradient(to right, #2563eb, #1e40af)', color: '#ffffff' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold mb-6">
                Streamline Your Product Development Lifecycle
              </h2>
              <p className="text-xl mb-8" style={{ color: '#dbeafe' }}>
                Purpose-built solution for food & beverage, chemicals, life sciences, 
                and personal care industries with comprehensive formulation management.
              </p>
              <div className="flex space-x-4">


                <Link to="/contact">
                
                 <button 
                  className="px-6 py-3 rounded-lg font-semibold transition-colors"
                  style={{ backgroundColor: '#f97316' }}
                  onMouseOver={(e) => e.target.style.backgroundColor = '#ea580c'}
                  onMouseOut={(e) => e.target.style.backgroundColor = '#f97316'}
                >
                  Get Started
                </button>
                
                </Link>
               
               
              </div>
            </div>
            <div>
              <img 
                src="https://images.unsplash.com/photo-1551434678-e076c223a692?w=600&h=400&fit=crop&crop=center" 
                alt="Product Development" 
                className="rounded-lg shadow-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        
        {/* Feature Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          
          {/* Card 1 - Centralized Product Development */}
          <div 
            className="rounded-xl shadow-lg hover:shadow-xl transition-shadow p-6"
            style={{ backgroundColor: '#ffffff', borderTop: '4px solid #f97316' }}
          >
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 rounded-lg flex items-center justify-center" style={{ backgroundColor: '#fed7aa' }}>
                <Database className="w-6 h-6" style={{ color: '#ea580c' }} />
              </div>
              <h3 className="ml-3 text-lg font-semibold" style={{ color: '#111827' }}>Centralized Management</h3>
            </div>
            <p className="mb-4" style={{ color: '#4b5563' }}>
              Single repository for all product data, formulations, and specifications with version control.
            </p>
            <div className="flex items-center space-x-4 text-sm">
              <div className="flex items-center" style={{ color: '#ea580c' }}>
                <CheckCircle className="w-4 h-4 mr-1" />
                <span>Formula Management</span>
              </div>
            </div>
          </div>

          {/* Card 2 - Regulatory Compliance */}
          <div 
            className="rounded-xl shadow-lg hover:shadow-xl transition-shadow p-6"
            style={{ backgroundColor: '#ffffff', borderTop: '4px solid #ef4444' }}
          >
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 rounded-lg flex items-center justify-center" style={{ backgroundColor: '#fecaca' }}>
                <Shield className="w-6 h-6" style={{ color: '#dc2626' }} />
              </div>
              <h3 className="ml-3 text-lg font-semibold" style={{ color: '#111827' }}>Compliance & Risk</h3>
            </div>
            <p className="mb-4" style={{ color: '#4b5563' }}>
              Automated compliance tracking for FDA, REACH, GHS and other international regulations.
            </p>
            <div className="flex items-center space-x-4 text-sm">
              <div className="flex items-center" style={{ color: '#dc2626' }}>
                <Globe className="w-4 h-4 mr-1" />
                <span>Global Standards</span>
              </div>
            </div>
          </div>

          {/* Card 3 - Collaboration */}
          <div 
            className="rounded-xl shadow-lg hover:shadow-xl transition-shadow p-6"
            style={{ backgroundColor: '#ffffff', borderTop: '4px solid #22c55e' }}
          >
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 rounded-lg flex items-center justify-center" style={{ backgroundColor: '#bbf7d0' }}>
                <Users className="w-6 h-6" style={{ color: '#16a34a' }} />
              </div>
              <h3 className="ml-3 text-lg font-semibold" style={{ color: '#111827' }}>Cross-functional Collaboration</h3>
            </div>
            <p className="mb-4" style={{ color: '#4b5563' }}>
              Connect R&D, quality, procurement, and manufacturing teams on unified platform.
            </p>
            <div className="flex items-center space-x-4 text-sm">
              <div className="flex items-center" style={{ color: '#16a34a' }}>
                <Zap className="w-4 h-4 mr-1" />
                <span>Real-time Sync</span>
              </div>
            </div>
          </div>

          {/* Card 4 - Innovation & Analytics */}
          <div 
            className="rounded-xl shadow-lg hover:shadow-xl transition-shadow p-6"
            style={{ backgroundColor: '#ffffff', borderTop: '4px solid #3b82f6' }}
          >
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 rounded-lg flex items-center justify-center" style={{ backgroundColor: '#dbeafe' }}>
                <TrendingUp className="w-6 h-6" style={{ color: '#2563eb' }} />
              </div>
              <h3 className="ml-3 text-lg font-semibold" style={{ color: '#111827' }}>Data-driven Innovation</h3>
            </div>
            <p className="mb-4" style={{ color: '#4b5563' }}>
              Advanced analytics and lifecycle intelligence for strategic product decisions.
            </p>
            <div className="flex items-center space-x-4 text-sm">
              <div className="flex items-center" style={{ color: '#2563eb' }}>
                <BarChart3 className="w-4 h-4 mr-1" />
                <span>Advanced Analytics</span>
              </div>
            </div>
          </div>

        </div>

        {/* Detailed Sections */}
        <div className="space-y-16">
          
          {/* Section 1 */}
          <section className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 rounded-xl flex items-center justify-center mr-4" style={{ backgroundColor: '#f97316' }}>
                  <Database className="w-8 h-8" style={{ color: '#ffffff' }} />
                </div>
                <h2 className="text-3xl font-bold" style={{ color: '#111827' }}>Centralized Product Development</h2>
              </div>
              <p className="text-lg mb-6" style={{ color: '#4b5563' }}>
                Streamline your entire product development lifecycle with a centralized repository 
                that manages everything from initial concept to final production.
              </p>
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <CheckCircle className="w-6 h-6 mt-0.5" style={{ color: '#f97316' }} />
                  <div>
                    <h4 className="font-semibold" style={{ color: '#111827' }}>Formula Management</h4>
                    <p style={{ color: '#4b5563' }}>Version control and change management for all formulations</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <CheckCircle className="w-6 h-6 mt-0.5" style={{ color: '#f97316' }} />
                  <div>
                    <h4 className="font-semibold" style={{ color: '#111827' }}>Single Source of Truth</h4>
                    <p style={{ color: '#4b5563' }}>Consistent data across all departments and teams</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <CheckCircle className="w-6 h-6 mt-0.5" style={{ color: '#f97316' }} />
                  <div>
                    <h4 className="font-semibold" style={{ color: '#111827' }}>Reduced Time-to-Market</h4>
                    <p style={{ color: '#4b5563' }}>Accelerated development cycles with streamlined processes</p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <img 
                src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=600&h=400&fit=crop&crop=center" 
                alt="Product Development Process" 
                className="rounded-xl shadow-lg"
              />
            </div>
          </section>

          {/* Section 2 */}
          <section className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="lg:order-2">
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 rounded-xl flex items-center justify-center mr-4" style={{ backgroundColor: '#ef4444' }}>
                  <Shield className="w-8 h-8" style={{ color: '#ffffff' }} />
                </div>
                <h2 className="text-3xl font-bold" style={{ color: '#111827' }}>Regulatory Compliance</h2>
              </div>
              <p className="text-lg mb-6" style={{ color: '#4b5563' }}>
                Ensure compliance with international regulations and manage product-related risks 
                with automated documentation and compliance tracking.
              </p>
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <CheckCircle className="w-6 h-6 mt-0.5" style={{ color: '#ef4444' }} />
                  <div>
                    <h4 className="font-semibold" style={{ color: '#111827' }}>FDA, REACH, GHS Compliance</h4>
                    <p style={{ color: '#4b5563' }}>Automated tracking of international standards</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <CheckCircle className="w-6 h-6 mt-0.5" style={{ color: '#ef4444' }} />
                  <div>
                    <h4 className="font-semibold" style={{ color: '#111827' }}>Auto-Generated Documentation</h4>
                    <p style={{ color: '#4b5563' }}>Safety data sheets, labels, and allergen declarations</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <CheckCircle className="w-6 h-6 mt-0.5" style={{ color: '#ef4444' }} />
                  <div>
                    <h4 className="font-semibold" style={{ color: '#111827' }}>Risk Mitigation</h4>
                    <p style={{ color: '#4b5563' }}>Proactive flagging of non-compliant ingredients</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="lg:order-1">
              <img 
                src="https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=600&h=400&fit=crop&crop=center" 
                alt="Regulatory Compliance" 
                className="rounded-xl shadow-lg"
              />
            </div>
          </section>

          {/* Section 3 */}
          <section className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 rounded-xl flex items-center justify-center mr-4" style={{ backgroundColor: '#22c55e' }}>
                  <Users className="w-8 h-8" style={{ color: '#ffffff' }} />
                </div>
                <h2 className="text-3xl font-bold" style={{ color: '#111827' }}>Enhanced Collaboration</h2>
              </div>
              <p className="text-lg mb-6" style={{ color: '#4b5563' }}>
                Break down silos and connect cross-functional teams with real-time visibility 
                into product specifications, test results, and production requirements.
              </p>
              <div className="grid grid-cols-2 gap-4 mb-6">
                <div className="p-4 rounded-lg text-center" style={{ backgroundColor: '#f0fdf4' }}>
                  <Beaker className="w-8 h-8 mx-auto mb-2" style={{ color: '#16a34a' }} />
                  <h4 className="font-semibold" style={{ color: '#14532d' }}>R&D Teams</h4>
                </div>
                <div className="p-4 rounded-lg text-center" style={{ backgroundColor: '#f0fdf4' }}>
                  <Target className="w-8 h-8 mx-auto mb-2" style={{ color: '#16a34a' }} />
                  <h4 className="font-semibold" style={{ color: '#14532d' }}>Quality Assurance</h4>
                </div>
                <div className="p-4 rounded-lg text-center" style={{ backgroundColor: '#f0fdf4' }}>
                  <FileText className="w-8 h-8 mx-auto mb-2" style={{ color: '#16a34a' }} />
                  <h4 className="font-semibold" style={{ color: '#14532d' }}>Procurement</h4>
                </div>
                <div className="p-4 rounded-lg text-center" style={{ backgroundColor: '#f0fdf4' }}>
                  <Settings className="w-8 h-8 mx-auto mb-2" style={{ color: '#16a34a' }} />
                  <h4 className="font-semibold" style={{ color: '#14532d' }}>Manufacturing</h4>
                </div>
              </div>
            </div>
            <div>
              <img 
                src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=600&h=400&fit=crop&crop=center" 
                alt="Team Collaboration" 
                className="rounded-xl shadow-lg"
              />
            </div>
          </section>

          {/* Section 4 */}
          <section className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="lg:order-2">
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 rounded-xl flex items-center justify-center mr-4" style={{ backgroundColor: '#3b82f6' }}>
                  <TrendingUp className="w-8 h-8" style={{ color: '#ffffff' }} />
                </div>
                <h2 className="text-3xl font-bold" style={{ color: '#111827' }}>Data-Driven Innovation</h2>
              </div>
              <p className="text-lg mb-6" style={{ color: '#4b5563' }}>
                Transform your organization into an innovation-driven enterprise with advanced 
                analytics and lifecycle intelligence for strategic decision-making.
              </p>
              <div className="p-6 rounded-xl mb-6" style={{ backgroundColor: '#eff6ff' }}>
                <div className="grid grid-cols-2 gap-6">
                  <div className="text-center">
                    <div className="text-3xl font-bold" style={{ color: '#2563eb' }}>85%</div>
                    <div style={{ color: '#1e40af' }}>Faster Decisions</div>
                  </div>
                  <div className="text-center">
                    <div className="text-3xl font-bold" style={{ color: '#2563eb' }}>40%</div>
                    <div style={{ color: '#1e40af' }}>Cost Reduction</div>
                  </div>
                  <div className="text-center">
                    <div className="text-3xl font-bold" style={{ color: '#2563eb' }}>92%</div>
                    <div style={{ color: '#1e40af' }}>Compliance Rate</div>
                  </div>
                  <div className="text-center">
                    <div className="text-3xl font-bold" style={{ color: '#2563eb' }}>60%</div>
                    <div style={{ color: '#1e40af' }}>Time Savings</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="lg:order-1">
              <img 
                src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&h=400&fit=crop&crop=center" 
                alt="Data Analytics" 
                className="rounded-xl shadow-lg"
              />
            </div>
          </section>

        </div>
      </main>

      {/* Call to Action */}
      <section className="py-16" style={{ background: 'linear-gradient(to right, #f97316, #ef4444)', color: '#ffffff' }}>
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold mb-6">Ready to Transform Your Product Development?</h2>
          <p className="text-xl mb-8" style={{ opacity: '0.9' }}>
            Join leading organizations using Infor PLM for Process to accelerate innovation, 
            ensure compliance, and drive competitive advantage.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              className="px-8 py-4 rounded-lg font-semibold text-lg transition-colors"
              style={{ backgroundColor: '#ffffff', color: '#ea580c' }}
              onMouseOver={(e) => e.target.style.backgroundColor = '#f3f4f6'}
              onMouseOut={(e) => e.target.style.backgroundColor = '#ffffff'}
            >
              Schedule Demo
            </button>
            <button 
              className="border-2 px-8 py-4 rounded-lg font-semibold text-lg transition-colors"
              style={{ borderColor: '#ffffff' }}
              onMouseOver={(e) => { e.target.style.backgroundColor = '#ffffff'; e.target.style.color = '#ea580c'; }}
              onMouseOut={(e) => { e.target.style.backgroundColor = 'transparent'; e.target.style.color = '#ffffff'; }}
            >
              Contact Sales
            </button>
          </div>
        </div>
      </section>

    </div>
  );
};

export default InforPLMProcess;
